import React from 'react';
import { Box, Image, Text, VStack, Link, IconButton, useColorModeValue, Flex} from '@chakra-ui/react';
import { FaYoutube } from 'react-icons/fa6';

const VideoCard = ({ video }) => {
  const cardBg = useColorModeValue('brand.800', 'brand.800');
  const titleColor = useColorModeValue('brand.300', 'brand.300');
  const accentColor = useColorModeValue('brand.accent', 'brand.accent');
  const secondaryAccentColor = useColorModeValue('brand.secondaryAccent', 'brand.secondaryAccent');

  // Helper function to extract YouTube video ID (useful if you only have full URLs)
  // You would typically use this if your JSON only stores full YouTube URLs,
  // and you want to construct the thumbnail URL programmatically.
  // For this setup, we expect thumbnailUrl to be provided directly in data.json.
//   const getYouTubeVideoId = (url) => {
//     const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
//     const match = url.match(regex);
//     return match ? match[1] : null;
//   };

  // Example of how to get a YouTube thumbnail if only video ID/URL is available:
  // const videoId = getYouTubeVideoId(video.youtubeUrl);
  // const youtubeThumbnail = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : video.thumbnailUrl;


  return (
    <Box
      w={{ base: "280px", md: "300px" }} // Responsive width for card
      borderRadius="xl"
      overflow="hidden"
      boxShadow="lg"
      bg={cardBg}
      p={4}
      transition="transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out"
      _hover={{ transform: 'translateY(-5px)', boxShadow: 'xl' }}
    >
      <VStack spacing={4} align="stretch">
        {/* Video Thumbnail */}
        <Image
          src={video.thumbnailUrl} // Use the thumbnail URL provided directly in JSON
          alt={`Thumbnail for ${video.title}`}
          objectFit="cover"
          w="100%"
          h="auto"
          borderRadius="lg"
          boxShadow="md"
          fallbackSrc="https://placehold.co/300x180/4A5568/FFFFFF?text=No+Video+Image" // Fallback if image fails
        />

        {/* Video Title */}
        <Text fontSize="xl" fontWeight="bold" color={titleColor} noOfLines={1}>
          {video.title}
        </Text>

        {/* YouTube Link Button */}
        <Flex justifyContent="center" mt={2}>
          <IconButton
            as={Link}
            href={video.youtubeUrl}
            isExternal
            aria-label="Watch on YouTube"
            icon={<FaYoutube />}
            size="lg"
            bg={accentColor}
            color="white"
            borderRadius="full"
            _hover={{ bg: secondaryAccentColor, transform: 'scale(1.1)' }}
          />
        </Flex>
      </VStack>
    </Box>
  );
};

export default VideoCard;